import { render, staticRenderFns } from "./api-keys.vue?vue&type=template&id=3dbf0c80&scoped=true&"
import script from "./api-keys.vue?vue&type=script&lang=js&"
export * from "./api-keys.vue?vue&type=script&lang=js&"
import style0 from "./api-keys.vue?vue&type=style&index=0&id=3dbf0c80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbf0c80",
  null
  
)

export default component.exports